"use client";
import { useAuthQuery } from "@stadium/services/apollo-client";
import { fetchUserDetail } from "@stadium/hooks/graphql/queries/current-user";
import { GetUserDocument } from "@stadium/hooks/graphql/operations";
const useFetchCurrentUserData = () => useAuthQuery(GetUserDocument);
const useFetchUserDetail = (variables) =>
  useAuthQuery(fetchUserDetail, {
    fetchPolicy: "cache-first",
    variables,
  });

export default useFetchCurrentUserData;
export { useFetchUserDetail };
